<template>
  <v-row class="timetable">
    <v-col cols="12">
      <ul class="grid-size overflow-x-hidden" style="overflow-y: scroll;">
        <div v-for="(contentType, index) in rowContentType" :key="`contentTimeTable_${index}`" class="content-timeline">
          <li v-for="(row, i) in contentType.sessions.size" :key="`contentTimeTable_row_${i}`">
            <div class="d-flex align-center full-height">
              <span
                v-for="session in contentType.sessions.get(row)"
                :key="session._id"
                :style="sessionStyle(session)"
                class="session sessionHeight text-truncate contentSessionStyle"
              >
                <v-menu
                  v-if="showMenu"
                  ref="menuChavaliers"
                  bottom
                  right
                  :close-on-content-click="false"
                  :offset-x="true"
                >
                  <template #activator="{ on, attrs }">
                    <ContentLabel :on="on" :attrs="attrs" :session-name="session.name" :content-name="contentName(contentType, session)" :icon="contentIcon(contentType, session)" :icon-color="iconColor(contentType, session)" />
                  </template>
                  <v-list v-show="disableAll" style="height: 200px">
                    <v-list-item
                      v-for="item in sessionAction"
                      v-if="!item.noshow.includes(contentType.wtype)"
                      :key="item.code"
                      class="pointer white-bg"
                      :disabled="isActionDisable(session,contentType, item)"
                      two-line
                      @click="item.click(session,contentType)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle v-if="isActionDisable(session,contentType, item) && item.disableMessage">{{ item.disableMessage }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <div v-else class="col-12 pa-0" @click="handleSessionClick(session)">
                  <ContentLabel :session-name="session.name" :content-name="contentName(contentType, session)" :icon="contentIcon(contentType, session)" :icon-color="iconColor(contentType, session)" />
                </div>
              </span>
            </div>
          </li>
        </div>
      </ul>
    </v-col>

    <FallModal v-if="fallModalOpen" :create-fall="true" />
  </v-row>
</template>

<script>
import { computed, ref, nextTick, inject, provide } from '@vue/composition-api';
import { computeSessionStyle, rowPerContentType, EventBus, sendNotification, getSessionColor } from '@/helpers/utils';
import { updateSessionPresence } from '@/helpers/amplify';
import { presenseStatus } from '@/helpers/variables';
import FallModal from '@/components/fall/FallModal.vue';
import ContentLabel from './ContentLabel.vue';
import store from '@/store';

export default {
  components: { ContentLabel, FallModal },
  props: {
    contentTypeValues: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  setup (props) {
    const search = ref(null);
    const sessions = computed(() => store.getters.dailySessions);
    const selectedSession = inject('selectedSession');
    const selectedParticipant = inject('selectedParticipant');
    const menuChavaliers = ref([]);
    const fallModalOpen = ref(false);
    const fallSession = ref({});
    const fallParticipant = ref({});
    const selectedFall = ref(null);

    const selectedContentType = ref([]);

    const handleSessionClick = session => {
      EventBus.$emit('closeDrawerState');
      EventBus.$emit('showEditSession', { session: session });
    };

    const iconColor = (content, session) => {
      switch (content.wtype) {
        case 'customer': {
          const participant = session.participants.find(p => p.uuid === content.uuid);
          if (participant && participant.presence_status === presenseStatus.ABSENT && !participant.presence) {
            return 'third';
          }
          return 'white';
        }
        default:
          return 'white';
      }
    };

    const contentIcon = (content, session) => {
      switch (content.wtype) {
        case 'customer': {
          const participant = session.participants.find(p => p.uuid === content.uuid);
          if (participant && participant.presence_status === presenseStatus.ABSENT && !participant.presence) {
            return 'mdi-close';
          }
          if (participant.horse) {
            return 'mdi-horse-variant';
          }
          return null;
        }
        case 'horse': {
          const horseHaveParticipant = (session.participants || []).some(p => p.horse === content.uuid);
          return horseHaveParticipant ? 'mdi-account' : null;
        }
        default:
          return null;
      }
    };

    const contentName = (content, session) => {
      switch (content.wtype) {
        case 'customer': {
          const foundParticipant = session.participants.find(participant => participant.uuid === content.uuid);

          if (foundParticipant && foundParticipant.presence_status === presenseStatus.ABSENT && !foundParticipant.presence) {
            return 'Absent';
          }

          if (foundParticipant && !!foundParticipant.horse) {
            const horseDetail = store.getters.horse(foundParticipant.horse);

            if (horseDetail) {
              return horseDetail.horse_name;
            }
          }

          return null;
        }
        case 'horse': {
          const participantWithHorse = session.participants.find(participant => participant.horse === content.uuid);

          if (participantWithHorse) {
            return `${participantWithHorse.firstname} ${participantWithHorse.lastname}`;
          }

          return null;
        }
        default:
          return '';
      }
    };

    const rowContentType = computed(() => rowPerContentType(props.contentTypeValues));

    const disableAll = inject('disableAll');
    const showHorseAssignList = inject('showHorseAssignList');
    const showParticipantHorseHistory = inject('showParticipantHorseHistory');

    const updateClickMenu = () => {
      const menu = menuChavaliers.value.find(mc => mc.isActive === true);
      if (menu) {
        nextTick(() => {
          menu.updateDimensions();
        });
      }
    };

    const showHorseTable = (session, contentType) => {
      updateClickMenu();
      selectedParticipant.value = contentType;
      selectedSession.value = session;

      const sessionParticipant = session.participants.find(c => c.uuid === contentType.uuid);

      selectedContentType.value = sessionParticipant && sessionParticipant.horse ? [store.getters.horse(sessionParticipant.horse)] : [];

      disableAll.value = false;
      showHorseAssignList.value = true;
    };

    const participantHorseHistory = (session, contentType) => {
      updateClickMenu();
      selectedParticipant.value = contentType;
      selectedSession.value = session;

      disableAll.value = false;
      showParticipantHorseHistory.value = true;
    };

    const absentParticipant = async (session, participant) => {
      if (!store.getters.canUserPerformAction) {
        return;
      }
      const updatedParticipants = await updateSessionPresence({ participant, session, status: presenseStatus.ABSENT });
      if (updatedParticipants.success) {
        sendNotification('success', `Cavalier ${participant.fullname} a été mis à jour avec succès.`);
      } else {
        sendNotification('error', 'Erreur lors de la mise à jour du cavalier');
      }
    };

    const registerFall = (session, participant) => {
      fallSession.value = session;
      const sessionParticipant = session ? session.participants.find(p => p.uuid === participant.uuid) : null;
      selectedFall.value = {
        uuid: null,
        session: session,
        ridder: {
          ...sessionParticipant,
          fullname: `${sessionParticipant.firstname} ${sessionParticipant.lastname}`
        },
        horse: sessionParticipant ? sessionParticipant.horse : null,
        description: null,
        firefighter: false,
        time: null
      };
      fallParticipant.value = participant;
      fallModalOpen.value = true;
    };

    const sessionAction = computed(() => {
      const items = [
        { name: 'Détail de la session', code: 'detail', click: session => handleSessionClick(session), noshow: [] },
        { name: 'Assigner le cheval au cavalier', code: 'rider_horse', click: (session, contentType) => showHorseTable(session, contentType), noshow: ['place', 'horse', 'collaborator'], disableMessage: 'Le participant est absent à la séance' },
        { name: 'Historique de monte', code: 'rider_horse_history', click: (session, contentType) => participantHorseHistory(session, contentType), noshow: ['place', 'horse', 'collaborator'], disableMessage: 'Le participant est absent à la séance' },
        { name: 'Cavalier absent', code: 'absent_cavalier', click: (session, contentType) => absentParticipant(session, contentType), noshow: ['place', 'horse', 'collaborator'], disableMessage: "Cavalier c'est déjà l'absence" },
        { name: 'Enregistrer une chute', code: 'register_fall', click: (session, contentType) => registerFall(session, contentType), noshow: ['place', 'horse', 'collaborator'], disableMessage: "Il n'est pas possible d'enregistrer la chute" }
      ];

      const contentWtype = props?.contentTypeValues?.length ? props.contentTypeValues[0].wtype : 'place';

      return items.filter(item => !item.noshow.includes(contentWtype));
    });

    const showMenu = computed(() => sessionAction.value.length > 1);

    const sessionStyle = session => {
      const { showOriginalSessionColor } = store.state;
      const { style } = computeSessionStyle(session, true);
      return `${style}background-color: ${showOriginalSessionColor ? getSessionColor(session) : session.color}`;
    };
    const filter = (_, searchValue, item) => item.horse_name.toLowerCase().includes(searchValue.toLowerCase());

    const isActionDisable = (session, contentType, menuItem) => {
      if (contentType.wtype === 'customer' && (menuItem.code === 'rider_horse' || menuItem.code === 'absent_cavalier')) {
        const sessionParticipant = (session.participants || []).find(p => p.uuid === contentType.uuid);

        if (sessionParticipant) {
          return sessionParticipant.presence_status === presenseStatus.ABSENT;
        }
      }
      return false;
    };

    const originalFall = ref({
      uuid: null,
      session: null,
      ridder: null,
      horse: null,
      description: null,
      firefighter: false,
      time: null
    });

    provide('createEditModal', fallModalOpen);
    provide('isEdit', ref(true));
    provide('selectedFall', selectedFall);
    provide('originalFall', originalFall);

    return { fallParticipant, fallSession, fallModalOpen, iconColor, contentIcon, contentName, isActionDisable, selectedContentType, menuChavaliers, showMenu, filter, search, disableAll, sessionAction, sessionStyle, sessions, rowContentType, handleSessionClick };
  }
};
</script>

<style>
  .v-application ul, .v-application ol{
    padding-left: 0;
  }

  .contentSessionStyle {
    display: flex !important;
    justify-content: space-between;
    padding-left: 0.3em;
  }
</style>
